import type { JSX } from 'react';
import { useEffect, useRef } from 'react';
import { fastBaseHostname } from '~/constantDefinitions';
import type { Font } from '../../utilities/fonts';

type Props = Pick<React.HTMLAttributes<HTMLElement>, 'style'> & {
  mediaId: string;
  accentColor?: string;
  font?: Font;
  playerDomId?: string;
  stickyOffsetTop?: number;
  autoScrollMarginTopPx?: number;
  hasDownloadControl?: boolean;
  hasAutoScrollControl?: boolean;
};

export const WistiaTranscript = ({
  mediaId,
  accentColor,
  font,
  style,
  playerDomId,
  autoScrollMarginTopPx,
  hasDownloadControl,
  hasAutoScrollControl,
}: Props): JSX.Element => {
  const wistiaTranscriptRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://${fastBaseHostname}/assets/external/transcript.js`;
    document.body.appendChild(script);
  }, []);

  return (
    <wistia-transcript
      ref={wistiaTranscriptRef}
      media-id={mediaId}
      accent-color={accentColor}
      font-family={font?.family}
      font-url={font?.url}
      style={style}
      player-dom-id={playerDomId}
      auto-scroll-margin-top-px={autoScrollMarginTopPx}
      has-download-control={hasDownloadControl}
      has-auto-scroll-control={hasAutoScrollControl}
    />
  );
};
